import { render } from "./CardLink.vue?vue&type=template&id=5b8ac56d"
const script = {}

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__